import React, { useEffect, useRef } from 'react';
import { AssetWrapperProps } from 'src/app/atoms/Asset/AssetWrapper';
import { FeedPostAssetCarouselContainer } from './FeedPostAssetCarousel.styles';
import ImageCard from '../ImageCard/ImageCard';
import LeftAlignedCarousel from 'molecules/LeftAlignedCarousel/LeftAlignedCarousel';
import { ColorModePropKeys } from 'styles/colors';

export interface Post {
  href?: string;
  image?: AssetWrapperProps['imageProps'];
  video?: AssetWrapperProps['videoProps'];
  imageMaxWidth?: number;
  title?: string;
  onClick?: () => void;
  cover?: boolean;
  background?: ColorModePropKeys;
}

interface FeedPostAssetCarouselProps {
  posts: Post[];
}

const FeedPostAssetCarousel = ({ posts }: FeedPostAssetCarouselProps): JSX.Element => {
  const carouselRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!carouselRef.current) return;

    const { right } = carouselRef.current.getBoundingClientRect();

    carouselRef.current.style.setProperty('--feed-post-slider-width', `calc(100% + ${Math.round(right)}px)`);
  }, []);

  return (
    <FeedPostAssetCarouselContainer ref={carouselRef}>
      <LeftAlignedCarousel>
        {posts.map((post, index) => (
          <ImageCard
            key={index}
            className='image-card-item'
            image={post.image}
            video={post.video}
            imageMaxWidth={posts[0].imageMaxWidth}
            imageCover={post.cover}
            background={post.background}
            title={
              post.title
                ? {
                    type: 'paragraph',
                    size: 'xl',
                    text: post.title,
                    fontWeight: 'font-weight-semibold',
                  }
                : undefined
            }
            href={post.href}
            onClick={post?.onClick}
          />
        ))}
      </LeftAlignedCarousel>
    </FeedPostAssetCarouselContainer>
  );
};

export default FeedPostAssetCarousel;
